<template>
  <div class="pdf-download">
    <div>
      <span> exe دانلود کاتالوگ اجرایی به فرمت </span>
      <br>
      <button class="download-button" @click="downloadPdf">کاتالوگ (exe)</button>
    </div>
    <br>

    <div>
      <span> PDF دانلود کاتالوگ به فرمت </span>
      <br>
      <button class="download-button" @click="downloadPdf2">کاتالوگ (pdf)</button>
    </div>
    <br>

    <div>
      <span> PDF دانلود رزومه شهرسازی پردیس آمایش سرزمین به فرمت </span>
      <br>
      <button class="download-button" @click="downloadPdf3">رزومه شهرسازی پردیس آمایش سرزمین</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OurCatalog',
  methods: {
    downloadPdf() {
      const pdfUrl = '1.exe';
      this.downloadFile(pdfUrl);
    },
    downloadPdf2() {
      const pdfUrl = '2.pdf';
      this.downloadFile(pdfUrl);
    },
    downloadPdf3() {
      const pdfUrl = '3.pdf';
      this.downloadFile(pdfUrl);
    },
    downloadFile(pdfUrl) {
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = pdfUrl.split('/').pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
</script>

<style scoped>
.pdf-download {
  font-size: 18px;
  margin-top: 180px; /* To accommodate the navbar */
  text-align: center;
}

.download-button {
  padding: 10px 20px;
  background-color: #ffffff; /* White background */
  color: #000000; /* Black text */
  border: 1px solid #000000; /* Black border */
  border-radius: 5px;
  cursor: pointer;
  transition: transform 0.3s ease, background-color 1s ease; /* Adjusted transition duration */
  margin-bottom: 10px; /* Add margin between buttons */
  margin-top: 10px; /* Add margin between buttons */

}

.download-button:hover {
  transform: scale(1.05); /* Scale up on hover */
  background-color: #000000; /* Black background on hover */
  color: #ffffff; /* White text */
}

.pdf-download span {
  color: #333; /* Color for the text in between links */
}
</style>
